export enum BloodTestTrackingStatus {
    Purchased = "purchased",
    Delivered = "delivered",
    TestDone = "test-done",
    SampleRegistered = "sample-registered",
    PickupRequested = "pickup-requested",
    DeliveredToLab = "delivered-to-laboratory",
    ReportGenerated = "report-generated",
    None = "none",
}
